/* eslint-disable camelcase */
/* eslint-disable react/no-array-index-key */
/* eslint-disable indent */
/* eslint-disable react/jsx-indent */
/* eslint-disable import/no-duplicates */
/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable max-len */
import moment from 'moment';
import React, { useEffect, useState } from 'react';
import { useLocation, useNavigate, useParams } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';

import DynamicSVGIcon from '../../Common/DynamicSVGIcon';
import {
  BodyContainer,
  HeaderContainer,
  HeaderText,
  NormalContent,
  Container,
  StatusContainer,
  UpdatedStatusText,
  Main,
  StatusColor,
  DetailsDropdownContainer,
  SelectableText,
  DetailWrapper,
  SidePanelIconDragger,
  SidePanelIcon
} from './WorkOrderDetails.style';

import DropArrow from '../../../assets/icons/layout/dropdownarrow.svg';
import { AlignedDiv } from '../../Common/CommonStyles';
import RenderDetails from './RenderDetails';
import AssignModal from './AssignModal';
import RenderButtons from './RenderButtons';
import Loader from '../../Loader/Loader';
import RenderLogs from './RenderLogs';
import { WorkOrderCreators } from '../../../views/WorkOrders/store';
import WOSidePanel from './WO_SidePanel';
import { getFormatedTimestamp } from '../../../services/utility/moment';
import Toast from '../../Common/Toast';
import { WO_CREATION_FROM } from '../../../constants';
import { useActions } from '../../../store/hooks/useActions';
import { getStringLocale } from '../../../constants/language';
import { FlexContainer } from '../../../globalStyles';
import {
  BackBlack,
  CancelBlack,
  close,
  SidePanelSvg
} from '../../../assets/icons';
import { share, checkList, attach } from '../../../assets/icons';
import PopUpModal from '../../Common/PopUpModal/Modal.view';

const WorkOrderDetails = () => {
  const {
    workOrderId,
    status,
    loading,
    error,
    lastCompletedState,
    nextActions
  } = useSelector((state) => state.workOrders);
  const navigate = useNavigate();
  const timeStamp = new Date();
  const [showAssignModal, setShowAssignModal] = useState(false);
  // const params = useParams();
  const { setWorkOrderDetail } = useActions();
  const dispatch = useDispatch();
  const { type: typeParam, workOrderId: workOrderIdParam } = useParams();
  useEffect(() => {
    if (typeParam && workOrderIdParam) {
      dispatch(
        WorkOrderCreators.getWorkOrderDetails({
          type: typeParam,
          workOrderId: workOrderIdParam
        })
      );
    }
  }, [typeParam, workOrderIdParam]);

  useEffect(() => {
    dispatch(WorkOrderCreators.resetWorkOrderDetails());
    // TODO: test
    setWorkOrderDetail({
      workOrderCreationFrom: WO_CREATION_FROM.WORK_ORDERS_LIST
    });
  }, []);

  const clearToastMessage = () => {
    dispatch(WorkOrderCreators.getWorkOrdersFailure({ error: '' }));
  };

  const [openedDetail, setOpenedDetail] = useState('');
  const [showSidePanel, setShowSidePanel] = useState(false);

  const location = useLocation();
  const { previousLocation } = location.state || {};
  return (
    <>
      {!loading ? (
        status && (
          <Container>
            <HeaderContainer>
              <AlignedDiv>
                <div
                  className='cursor'
                  onClick={() => {
                    if (previousLocation) {
                      navigate(previousLocation);
                    } else {
                      navigate('/home/work_orders');
                    }
                  }}
                  style={{ paddingRight: '1rem' }}
                >
                  <DynamicSVGIcon
                    iconUrl={DropArrow}
                    width='2.2rem'
                    rotate={180}
                  />
                </div>
                <HeaderText>{`${workOrderId} | ${typeParam}`}</HeaderText>
              </AlignedDiv>
            </HeaderContainer>
            <BodyContainer>
              <Main>
                <div style={{ width: '96%' }}>
                  <StatusContainer>
                    <div>
                      <NormalContent>
                        {getStringLocale('Status', 'en')}
                      </NormalContent>
                      <FlexContainer
                        className='jc_spacebetween ai_center'
                        style={{ gap: '1rem' }}
                      >
                        <StatusColor />
                        <NormalContent className='imp'>
                          {lastCompletedState}
                        </NormalContent>
                      </FlexContainer>
                    </div>
                    <div>
                      <UpdatedStatusText>
                        {getStringLocale('Last Status updated', 'en')}
                      </UpdatedStatusText>
                      <UpdatedStatusText>
                        {getFormatedTimestamp(timeStamp)}
                      </UpdatedStatusText>
                    </div>
                  </StatusContainer>
                  <RenderButtons setShowAssignModal={setShowAssignModal} />
                </div>
                <div>
                  <div>
                    <DetailsDropdownContainer
                      onClick={() => {
                        if (openedDetail !== getStringLocale('Details', 'en')) {
                          setOpenedDetail(getStringLocale('Details', 'en'));
                        } else {
                          setOpenedDetail('');
                        }
                      }}
                    >
                      <SelectableText>
                        {getStringLocale('Details', 'en')}
                      </SelectableText>
                      <div>
                        <DynamicSVGIcon
                          iconUrl={BackBlack}
                          width='3.5rem'
                          rotate={
                            openedDetail === getStringLocale('Details', 'en')
                              ? 90
                              : 270
                          }
                        />
                      </div>
                    </DetailsDropdownContainer>
                    <DetailWrapper
                      className={
                        openedDetail === getStringLocale('Details', 'en')
                          ? 'visible'
                          : ''
                      }
                    >
                      <RenderDetails />
                    </DetailWrapper>
                  </div>
                  <div>
                    <DetailsDropdownContainer
                      onClick={() => {
                        if (
                          openedDetail !== getStringLocale('Activity Log', 'en')
                        ) {
                          setOpenedDetail(
                            getStringLocale('Activity Log', 'en')
                          );
                        } else {
                          setOpenedDetail('');
                        }
                      }}
                    >
                      <SelectableText>
                        {getStringLocale('Activity Log', 'en')}
                      </SelectableText>
                      <div>
                        <DynamicSVGIcon
                          iconUrl={BackBlack}
                          width='3.5rem'
                          rotate={
                            openedDetail ===
                            getStringLocale('Activity Log', 'en')
                              ? 90
                              : 270
                          }
                        />
                      </div>
                    </DetailsDropdownContainer>

                    <DetailWrapper
                      className={
                        openedDetail === getStringLocale('Activity Log', 'en')
                          ? 'visible'
                          : ''
                      }
                    >
                      <RenderLogs
                        workOrderId={workOrderId}
                        const
                        tab='Activity Log'
                      />
                    </DetailWrapper>
                  </div>
                  <div>
                    <DetailsDropdownContainer
                      onClick={() => {
                        if (openedDetail !== getStringLocale('Remarks', 'en')) {
                          setOpenedDetail(getStringLocale('Remarks', 'en'));
                        } else {
                          setOpenedDetail('');
                        }
                      }}
                    >
                      <SelectableText>
                        {getStringLocale('Remarks', 'en')}
                      </SelectableText>
                      <div>
                        <DynamicSVGIcon
                          iconUrl={BackBlack}
                          width='3.5rem'
                          rotate={
                            openedDetail === getStringLocale('Remarks', 'en')
                              ? 90
                              : 270
                          }
                        />
                      </div>
                    </DetailsDropdownContainer>

                    <DetailWrapper
                      style={{ padding: '2rem 1rem' }}
                      className={
                        openedDetail === getStringLocale('Remarks', 'en')
                          ? 'visible'
                          : ''
                      }
                    >
                      <RenderLogs
                        workOrderId={workOrderId}
                        const
                        tab='Remarks'
                      />
                    </DetailWrapper>
                  </div>
                  {nextActions.some(
                    (item) => item.value.toLowerCase() === 'addparts'
                  ) && (
                    <div>
                      <DetailsDropdownContainer
                        onClick={() => {
                          if (
                            openedDetail !==
                            getStringLocale('Part Request', 'en')
                          ) {
                            setOpenedDetail(
                              getStringLocale('Part Request', 'en')
                            );
                          } else {
                            setOpenedDetail('');
                          }
                        }}
                      >
                        <SelectableText>
                          {getStringLocale('Part Request', 'en')}
                        </SelectableText>
                        <div>
                          <DynamicSVGIcon
                            iconUrl={BackBlack}
                            width='3.5rem'
                            rotate={
                              openedDetail ===
                              getStringLocale('Part Request', 'en')
                                ? 90
                                : 270
                            }
                          />
                        </div>
                      </DetailsDropdownContainer>

                      <DetailWrapper
                        className={
                          openedDetail === getStringLocale('Part Request', 'en')
                            ? 'visible'
                            : ''
                        }
                      >
                        <RenderDetails detailType='Part Request' />
                      </DetailWrapper>
                    </div>
                  )}
                </div>
              </Main>
              <SidePanelIcon
                onClick={() => {
                  setShowSidePanel(true);
                }}
              >
                <div>
                  <DynamicSVGIcon iconUrl={SidePanelSvg} width='2rem' />
                </div>
              </SidePanelIcon>
              <SidePanelIconDragger>
                <div style={{ fontSize: 0, padding: '1rem' }}>
                  <DynamicSVGIcon iconUrl={share} width='2rem' />
                </div>
                <div style={{ fontSize: 0, padding: '1rem' }}>
                  <DynamicSVGIcon iconUrl={attach} width='2rem' />
                </div>
                <div style={{ fontSize: 0, padding: '1rem' }}>
                  <DynamicSVGIcon iconUrl={checkList} width='2rem' />
                </div>
              </SidePanelIconDragger>

              {/* <WOSidePanel
                typeParam={typeParam}
                workOrderIdParam={workOrderIdParam}
              /> */}
            </BodyContainer>
            {showAssignModal && (
              <AssignModal setShowAssignModal={setShowAssignModal} />
            )}
            {showSidePanel && (
              <PopUpModal
                style={{
                  height: '94vh',
                  backgroundColor: '#FFFFFF',
                  position: 'relative'
                }}
                closeModalHandler={() => {
                  setShowSidePanel(false);
                }}
                width={window?.innerWidth >= 768 ? '90%' : '100%'}
              >
                <div
                  style={{ textAlign: 'end', marginBottom: '1rem' }}
                  onClick={() => {
                    setShowSidePanel(false);
                  }}
                >
                  <DynamicSVGIcon iconUrl={CancelBlack} width='1.5rem' />
                </div>
                <WOSidePanel
                  typeParam={typeParam}
                  workOrderIdParam={workOrderIdParam}
                  setShowSidePanel={setShowSidePanel}
                />
              </PopUpModal>
            )}
          </Container>
        )
      ) : (
        <Loader />
      )}
      {error && (
        <Toast
          style={{ right: 20 }}
          fn={clearToastMessage}
          header='Error'
          message={error}
        />
      )}
    </>
  );
};

export default WorkOrderDetails;
